import { render } from "./TimeCardsDetail.vue?vue&type=template&id=1e9f0c1d"
import script from "./TimeCardsDetail.vue?vue&type=script&lang=ts"
export * from "./TimeCardsDetail.vue?vue&type=script&lang=ts"
script.render = render

export default script